<template>
  <div class="reviews-page leave-review-page">
    <div class="reviews-page__container">
      <nav class="reviews-page__breadcrumbs" aria-label="Хлебные крошки">
        <ol>
          <li>
            <router-link to="/">Главная</router-link>
            <img src="@/assets/svg/arrow-mini.svg" alt="" />
          </li>
          <li>
            <router-link to="/about">О центре</router-link>
            <img src="@/assets/svg/arrow-mini.svg" alt="" />
          </li>
          <li>
            <router-link to="/about/reviews">Отзывы</router-link>
            <img src="@/assets/svg/arrow-mini.svg" alt="" />
          </li>
          <li>
            <span aria-current="page">Оставить отзыв</span>
          </li>
        </ol>
      </nav>

      <section class="leave-review-hero">
        <div class="leave-review-hero__content">
          <h1 class="leave-review-hero__title">Оставить отзыв</h1>
          <p class="leave-review-hero__lead">
            Расскажите о своём опыте. Отзыв не публикуется сразу — сначала его проверят
            модераторы.
          </p>
        </div>
        <div class="leave-review-hero__decor" aria-hidden="true">
          <div class="leave-review-hero__orb"></div>
        </div>
      </section>

      <section class="leave-review-card" aria-label="Форма отзыва">
        <LeaveReviewForm />
      </section>
    </div>
  </div>
</template>

<script>
import LeaveReviewForm from '@/components/Reviews/LeaveReviewForm.vue'

export default {
  name: 'LeaveReview',
  components: { LeaveReviewForm },
  metaInfo() {
    return {
      title: 'Оставить отзыв | Алтайский краевой клинический перинатальный центр ДАР',
      meta: [
        {
          name: 'description',
          content: 'Оставьте отзыв о работе перинатального центра ДАР',
        },
      ],
    }
  },
}
</script>
